export default __webpack_public_path__ + "static/dei-n5-5711ed3ab050f7f02f0f7b15ce3296da.svg";